<div class="flex flex-col flex-auto min-w-0">

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <div class="flex flex-col-reverse md:flex-row gap-2 w-full ">
            <!--Page emulation-->
            <div class="col-span-2 flex flex-col w-full bg-card shadow-2xl m-2 z-20">
                <div [ngSwitch]="internalDocID" #printableDoc id="printableDoc">
                    <div class="w-full max-w-full">
                        <acord-pacient-informat-sib-v2-template *ngSwitchCase="DocummentID.API_SB_V2"></acord-pacient-informat-sib-v2-template>
                        <basic-info-template *ngSwitchCase="DocummentID.BASIC_INF"></basic-info-template>
                        <buletin-informativ-sib-v2-template *ngSwitchCase="DocummentID.BUL_INFO_SB_V1"></buletin-informativ-sib-v2-template>
                        <gdpr-sib-v1-template *ngSwitchCase="DocummentID.GDPR_AGREE_SB_V1"></gdpr-sib-v1-template>
                    </div>
                </div>
            </div>

            <div class="flex flex-col bg-card shadow m-2 md:-ml-4 z-10 w-full md:max-w-1/3 p-8 md:rounded-r-2xl"
                 [@fadeInLeft]="'true'">
                <h1 class="text-2xl font-bold">Informatii document</h1>
                <mat-divider class="mb-4"></mat-divider>
                <audit-component *ngIf="document?.createdOn"
                    [auditData]="document"></audit-component>
                <mat-divider></mat-divider>

                <div class="flex flex-row gap-2 items-center p-4">
                    <mat-icon
                        class="icon-size-8"
                        matPrefix
                        [svgIcon]="'mat_outline:draw'"></mat-icon>
                    <div class="flex flex-col leading-tight">
                        <div class="font-bold">Semnat de pacient la data de: </div>
                        <div>{{getDateString(flow?.userCompletionTime)}}</div>
                    </div>
                </div>

                <mat-divider></mat-divider>
                <div class="flex flex-row gap-2 items-center p-4">
                    <mat-icon
                        class="icon-size-8"
                        matPrefix
                        [svgIcon]="'heroicons_outline:document-check'"></mat-icon>
                    <div class="flex flex-col leading-tight">
                        <div class="font-bold">Document aceptat la data de: </div>
                        {{getDateString(flow?.clinicUserReviewCompletionTime)}}
                    </div>
                </div>


                <mat-divider></mat-divider>
                <div class="flex flex-row gap-2 items-center p-4">
                    <mat-icon
                        class="icon-size-8"
                        matPrefix
                        [svgIcon]="'mat_outline:notifications'"></mat-icon>
                    <div class="flex flex-col leading-tight">
                        <div class="font-bold">Notificare semnatura: {{getNotificationActivated()}}</div>
                        <div>Pacientul a fost notificat in legatura cu acordul dat la data: {{getDateString(flow?.userNotificationCompletionTime)}}</div>
                        <div>Tipul notificarii: {{flow?.notificationType}}</div>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <div class="flex flex-row gap-2 justify-center mt-4">
                    <button  mat-button class="rounded-lg my-auto" matTooltip="{{ 'Back' | transloco }}"
                    (click)="backClicked()"
                    >
                        <mat-icon svgIcon="mat_solid:arrow_back"></mat-icon>
                        <span class="ml-2">{{'Back' | transloco}}</span>
                    </button>
                    <button *ngIf="canPrint()"
                        mat-button class="rounded-lg my-auto" matTooltip="{{ 'Print' | transloco }}"
                             (click)="printDoc()">
                        <mat-icon svgIcon="heroicons_outline:printer"></mat-icon>
                        <span class="ml-2">{{'Print' | transloco}}</span>
                    </button>
                </div>
            </div>

        </div>

    </div>

</div>
